import React, { useMemo, useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from 'classnames';

const GenericCarousel = ({
    children,
    className = '',
    style,
    showIndicators = true
}) => {
    const items = useMemo(() => React.Children.toArray(children), [children]);
    const totalSlides = items.length;

    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (index > totalSlides - 1) {
            setIndex(0);
        }
    }, [totalSlides, index]);

    const handleSelect = (selectedIndex) => {
        if (selectedIndex === index) return;
        setIndex(selectedIndex);
    };

    const showControls = totalSlides > 1;
    const showCustomIndicators = showIndicators && totalSlides > 1;

    return (
        <>
            <Carousel
                style={style}
                activeIndex={index}
                className={`genericCarousel ${className}`}
                onSelect={handleSelect}
                prevIcon={
                    showControls ? (
                        <FontAwesomeIcon icon="chevron-left" className="preto" />
                    ) : null
                }
                nextIcon={
                    showControls ? (
                        <FontAwesomeIcon icon="chevron-right" className="preto" />
                    ) : null
                }
                controls={showControls}
                indicators={false}
                interval={null}
            >
                {items.map((item, i) => (
                    <Carousel.Item key={i}>
                        {item}
                    </Carousel.Item>
                ))}
            </Carousel>

            {showCustomIndicators ? (
                <div className="customIndicatorsContainer mt-2">
                    {items.map((item, i) => {
                        const isActiveIndicator = i === index;

                        return (
                            <div
                                key={i}
                                className={classnames(
                                    'mr-2 s20 rad10 p-1 d-inline-block',
                                    {
                                        click: !isActiveIndicator,
                                        hover: !isActiveIndicator,
                                        hteen3: !isActiveIndicator,
                                        teen3: !isActiveIndicator,
                                        teen1: isActiveIndicator,
                                    }
                                )}
                                onClick={() => handleSelect(i)}
                            >
                                <FontAwesomeIcon
                                    icon={["far", isActiveIndicator ? 'dot-circle' : 'circle']}
                                />
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div />
            )}
        </>
    );
};

export default GenericCarousel;